// Proprietà e costanti di configurazione per la tabella calibrazioni

export const tableColumns = [
  { name: "row_num", title:"#", getCellValue: row => row.row_num, isNumber: true },
  { name: "id", title: "ID", getCellValue: row => row.id, isNumber: true },
  { name: "actions", title: "Actions", getCellValue: row => row },
  { name: "created_at", title: "Created At", getCellValue: row => row.created_at },
  { name: "customer_username", title: "Customer", getCellValue: row => row.customer_username },
  { name: "tech_username", title: "Tech", getCellValue: row => row.tech_username },
  { name: "service_activity", title: "Activity Type", getCellValue: row => row.service_activity },
  { name: "service_issue", title: "Issue", getCellValue: row => row.service_issue },
  { name: "status", title: "Status", getCellValue: row => row.status },
  { name: "service_time", title: "Effort (min)", getCellValue: row => row.service_time, isNumber: true },
  { name: "car", title: "Car", getCellValue: row => row.car_brand },
  { name: "system_type", title: "System Type", getCellValue: row => row.system_type },
  { name: "ecu_type", title: "ECU", getCellValue: row => row.ecu_type },
  { name: "system_fuel", title: "Fuel", getCellValue: row => row.system_fuel },
  { name: "system_channel", title: "Channel", getCellValue: row => row.system_channel },
  { name: "system_brand", title: "Brand", getCellValue: row => row.system_brand },
];

export const tableColumnWidths = [
  { columnName: 'row_num', width: 60 },
  { columnName: 'id', width: 60 },
  { columnName: 'actions', width: 120 },  
  { columnName: 'customer_username', width: 120 },
  { columnName: 'tech_username', width: 120 },  
  { columnName: 'created_at', width: 120 },
  { columnName: 'updated_at', width: 120 },  
  { columnName: 'service_activity', width: 120 },
  { columnName: 'service_issue', width: 200 },
  { columnName: 'status', width: 100 },
  { columnName: 'service_time', width: 90 },
  { columnName: 'car', width: 250 },  
  { columnName: 'system_type', width: 90 },
  { columnName: 'ecu_type', width: 120 },
  { columnName: 'system_fuel', width: 90 },
  { columnName: 'system_channel', width: 90 },
  { columnName: 'system_brand', width: 120 },  
];

/**
 * @type {import('@devexpress/dx-react-grid-material-ui').ColumnExtension[]}
 */
export const tableColumnExtensions = [
  { columnName: 'row_num', align: 'right' },
  { columnName: 'id', align: 'right' },
  { columnName: 'created_at', align: 'right' },
  { columnName: 'service_time', align: 'right' },
];

export const tableFilteringStateColumnExtensions = [  
  { columnName: 'row_num', filteringEnabled: false },
  { columnName: 'id', filteringEnabled: false },
  { columnName: 'actions', filteringEnabled: false },  
  { columnName: 'customer_username', filteringEnabled: true },
  { columnName: 'tech_username', filteringEnabled: true },
  { columnName: 'created_at', filteringEnabled: false },
  { columnName: 'updated_at', filteringEnabled: false },  
  { columnName: 'service_activity', filteringEnabled: true },
  { columnName: 'service_issue', filteringEnabled: true },
  { columnName: 'status', filteringEnabled: true },
  { columnName: 'service_time', filteringEnabled: false },
  { columnName: 'car', filteringEnabled: true },  
  { columnName: 'system_type', filteringEnabled: true },
  { columnName: 'ecu_type', filteringEnabled: true },
  { columnName: 'system_fuel', filteringEnabled: false },
  { columnName: 'system_channel', filteringEnabled: true },
  { columnName: 'system_brand', filteringEnabled: true },  
];
